import React from 'react';
import "../assets/style.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../src/assets/chardham.png';

const AccountDetails = () => {
    return (
        <>
            <section>
                
            <div className='blog_main'  style={{
              backgroundImage: `url("https://shivshankartirthyatra.com/blog/wp-content/uploads/2025/02/banner.png")`,
             backgroundSize: "cover",
             backgroundPosition: "right 0px bottom 0px;",
             backgroundRepeat:"no-repat",
             display: "flex",
             alignItems: "center",
             padding:"130px 0",
             justifyContent: "center",
             color: "white",  // Adjust text color for visibility

             

        }}>
            <div className='d-flex align-items-center'>
                <div className='blog_main_content'>
                    <h1>Om Shiv Shankar Tirth Yatra </h1>

                </div>
            </div>
            
       </div>

       <div className='container mt-5'>
            <div className="row justify-content-center">
                <div className='col-lg-8'>
                    <div class="account_details">
                        <div class="card accout-card">
                            <div className='card-header'>
                                <h2 className='text-white mb-0'>Bank Account Details</h2>
                            </div>
                            <div class="card-body">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Account Name:</td>
                                            <td><b>Om Shiv Shankar Tirth Yatra</b></td>
                                        </tr>
                                        <tr>
                                            <td>Bank Name:</td>
                                            <td><b>State Bank of India</b></td>
                                        </tr>
                                        <tr>
                                            <td>Branch:</td>
                                            <td><b>Malviya Nagar</b></td>
                                        </tr>
                                        <tr>
                                            <td>Account Number:</td>
                                            <td><b>43312198408</b></td>
                                        </tr>
                                        <tr className='border-0'>
                                            <td>IFSC Code:</td>
                                            <td><b>SBIN0017670</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='col-lg-6'>
                    <div class="account_details">
                        <div class="card accout-card">
                            <div className='card-header'>
                                <h2 class="text-white mb-0">Payment Methods</h2>
                            </div>
                            <div class="card-body">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Online Bank Transfer</td>
                                            <td> <b>UPI (9460938009)</b></td>
                                        </tr>
                                        <tr>
                                            <td>Cheque Deposit (Payable to Om Shiv Shankar Tirth Yatra)</td>
                                            <td> <b>Cash Deposit (As per company policy)</b> </td>
                                        </tr>
                                        <tr className='border-0'>
                                            <td>Cheque Deposit (Payable to Om Shiv Shankar Tirth Yatra)</td>
                                            <td> <b>Cash Deposit (As per company policy)</b> </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
                <div className='col-lg-6'>
                    <div class="account_details">
                        <div class="card accout-card">
                            <div className='card-header'>
                                <h2 class="text-white mb-0"> Contact</h2>
                            </div>
                            <div class="card-body">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Phone/WhatsApp:</td>
                                            <td> <b> 9460938009</b></td>
                                        </tr>
                                        <tr>
                                            <td>Email:</td>
                                            <td> <b>omshankartirthyatra@gmail.com</b> </td>
                                        </tr>
                                        <tr className='border-0'>
                                            <td>Cheque Deposit (Payable to Om Shiv Shankar Tirth Yatra)</td>
                                            <td> <b>Cash Deposit (As per company policy)</b> </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
           
       </div>

            </section>
        </>
    )
}
export default AccountDetails;